import React from "react";
import { Link } from "react-router-dom";

export const subAdminColumns = ({handleEdit, handleDelete, PAGE_SIZE, viewPermission}) => [
   {
    label: "S.No",
    width: 50,
    render: (row, index, page) =>
      (page - 1) * PAGE_SIZE + index + 1,
  },
  {
    label: "Sub Admin",
    render: (row) => 
        <div className="userdet" bis_skin_checked="1"><div bis_skin_checked="1">
            <i className="far fa-user"></i> {row.name}</div><div bis_skin_checked="1"><i className="far fa-mobile"></i>{row.mobile}</div><div bis_skin_checked="1">
            <i className="far fa-envelope"></i> {row.email}</div></div>,    
  }
  ,
  {
  label: "Permission",
  render: (row) => (
    <div>
      <Link onClick={() => viewPermission(row?._id)}>View Permission</Link>
    </div>
  )
}
,
  {
    label: "Status",
    render: (row) => (
      <div className="checkbox-wrapper-8">
        <input
          className="tgl tgl-skewed"
          type="checkbox"
          checked={row.status === "Active"}
          readOnly
        />
        <label
          className="tgl-btn"
          data-tg-off="Inactive"
          data-tg-on="Active"
        />
      </div>
    ),
  },
  {
    label: "Action",
    width: 120,
    render: (row) => (
      <ul className="actionlist p-0">
        <li>
          <Link  onClick={() => handleEdit(row)}>
            <i className="fa fa-edit" />
          </Link>
        </li>
        <li>
          <Link  onClick={() => handleDelete(row._id)}>
            <i className="fa fa-trash" />
          </Link>
        </li>
      </ul>
    ),
  },
  
  
];
